export enum STAGE {
  LOCAL = 'local',
  BETA = 'beta',
  GAMMA = 'gamma',
  Prod = 'prod',
}
